// Basic React component
import React from 'react'
import { useIntl } from 'react-intl'

import { SECONDARY } from 'app/constants/button'
import { SubscriberMenuAction } from 'app/constants/subscriberCRM'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const InviteLimitExceedDialog = (props) => {
  const {
    isShowLimitDialog,
    setIsShowLimitDialog,
    selected,
    onAction,
    MAX_INVITE_LIMIT,
  } = props
  const { formatMessage } = useIntl()
  const slicedSubscriberIds = selected.slice(0, MAX_INVITE_LIMIT.number)

  return (
    <SubmitDialog
      id="dialog-invite-subscriber"
      open={isShowLimitDialog}
      type={SECONDARY}
      title={formatMessage({
        id: 'invite.limitExceed.title',
      })}
      description={formatMessage(
        {
          id: 'invite.limitExceed.message',
        },
        {
          limit: MAX_INVITE_LIMIT.text,
        },
      )}
      submitText={formatMessage(
        {
          id: 'action.invite',
        },
        {
          value: null,
        },
      )}
      onSubmit={() => {
        onAction(SubscriberMenuAction.INVITE, slicedSubscriberIds)
        setIsShowLimitDialog()
      }}
      closeText={formatMessage({
        id: 'text.close',
      })}
      onClose={() => setIsShowLimitDialog(false)}
    />
  )
}

export default InviteLimitExceedDialog
